'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Wix = require('./Wix.mock');

var _Wix2 = _interopRequireDefault(_Wix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixSdkWrapper = function () {
  function WixSdkWrapper() {
    (0, _classCallCheck3.default)(this, WixSdkWrapper);

    this.init();
  }

  (0, _createClass3.default)(WixSdkWrapper, [{
    key: 'wixSdkIsAvailable',
    value: function wixSdkIsAvailable() {
      try {
        return typeof window !== 'undefined' && typeof window.Wix !== 'undefined' && typeof window.Wix.Utils.getCompId === 'function'; //getCompId function is only available is the TPA version of the sdk
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'init',
    value: function init() {
      try {
        if (this.wixSdkIsAvailable()) {
          //Wix Sdk is on the window
          (0, _assign2.default)(this, _Wix2.default, window.Wix);
          this.isMock = false;
        } else {
          (0, _assign2.default)(this, _Wix2.default);
          this.isMock = true;
        }
      } catch (e) {
        (0, _assign2.default)(this, _Wix2.default);
        this.isMock = true;
      }
    }
  }]);
  return WixSdkWrapper;
}();

exports.default = new WixSdkWrapper();